import React from 'react';
import {
  AddCircleIcons,
  SubtractCircleIcons,
} from '../../../../../icons/icons';
import { Button, Drawer, TableColumn } from '../../../../../ui';
import { Column } from '../Functions/GetColumns';

type ColumnConfigurationProps<T> = {
  isOpen: boolean;
  onCloseDrawer: () => void;
  columns: Column[];
  setColumns: (value: ((prevState: Column[]) => Column[]) | Column[]) => void;
  getColumns: TableColumn<T>[];
  jobSkills: string[];
};

export const ColumnConfiguration = <T extends object>({
  isOpen,
  onCloseDrawer,
  columns,
  setColumns,
  getColumns,
  jobSkills,
}: ColumnConfigurationProps<T>) => {
  // const {columns, setColumns, getColumns} = GetColumns();

  const allColumns = jobSkills.map((skill) => {
    const upperCased = skill.toUpperCase();
    return {
      key: upperCased,
      label: upperCased,
      width: '250px',
      align: 'left' as const,
      disableSort: true,
    };
  });

  const getColumnKeys = new Set(getColumns.map((item) => item.key));

  const difference = allColumns.filter((item) => !getColumnKeys.has(item.key));

  return (
    <Drawer
        isOpen={isOpen}
        onClose={onCloseDrawer}
        footerContent={
          <div className='flex justify-end gap-5 w-full'>
            <Button label='Close' onClick={onCloseDrawer} variant='secondary' />{ ' ' }
          </div>
        }
        title='Select Column'
        width='w-full md:w-3/5'
    >
      <div className='flex gap-3.5'>
        <div className='flex gap-3 flex-col w-1/2 bg-gray-100 p-4 rounded-lg'>
          <h3 className='font-semibold'>Column List</h3>
          { difference.map((column) => (
            <button
                key={column.key}
                onClick={() => {
                  setColumns([...columns, { title: column.label }]);
                }}
                className='px-4 py-2 items-center flex gap-3 text-sm bg-white text-primary-main text-start outline outline-1 outline-primary-main rounded-full'
            >
              <AddCircleIcons /> { column.label }
            </button>
          )) }
        </div>
        <div className='flex gap-3 flex-col w-1/2 bg-gray-100 p-4 rounded-lg'>
          <h3 className='font-semibold'>Selected Columns</h3>
          { getColumns.map((column) => (
            <button
                key={String(column.key)}
                onClick={() => {
                  setColumns(columns.filter((c) => c.title !== column.label));
                }}
                className='px-4 py-2 items-center flex gap-3 text-sm bg-white text-primary-main text-start outline outline-1 outline-primary-main rounded-full'
            >
              <SubtractCircleIcons /> { column.label }
            </button>
          )) }
        </div>
      </div>
    </Drawer>
  );
};
